import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import { useTranslation } from "react-i18next";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { formatDateTime } from "@utils/dateFormat";
import { DynamicLink } from "./DynamicLink";
import { useAlert } from "./hook/useAlert";
import { IAlert } from "./interface/IAlert";
import { VariantCardActions } from "./VariantCardActions";

interface IParams {
    alert: IAlert;
    getAlertList(): Promise<void>;
}

export const Alert = (props: IParams) => {
    const { t } = useTranslation("common");

    const { alert, getAlertList } = props;
    const { id, createdAt, iconName, navLink, navLinkLabel, message } = alert;
    const alertDate = formatDateTime(createdAt);

    const { removeAlert, removeAlertState, isLoading } = useAlert(id, getAlertList);

    let iconSrc;
    try {
        iconSrc = require(`../../static/img/icons/${iconName}.png`);
    } catch (e) {
        iconSrc = "error";
    }

    return (
        <Card className="alerts-page-card" elevation={2}>
            <CardContent>
                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={1} xs={2}>
                        <Grid container justify="center">
                            <img alt={iconName} src={iconSrc} width="30px" height="30px" />
                        </Grid>
                    </Grid>
                    <Grid item md={8} sm={7} xs={10}>
                        <Typography variant="body1">{message}</Typography>
                        <Typography color="primary" variant="body1">
                            {alertDate}
                        </Typography>
                    </Grid>
                    <Hidden xsDown>
                        <Grid item sm={3} xs={12}>
                            <Grid
                                alignItems="center"
                                className="alerts-page-card__actions"
                                container
                                justify="flex-end"
                                spacing={4}
                            >
                                {navLinkLabel && (
                                    <Grid item md={7} sm={8} xs={6}>
                                        <DynamicLink link={navLink}>
                                            <Button color="secondary" fullWidth variant="contained">
                                                {t(`${navLinkLabel}` as any)}
                                            </Button>
                                        </DynamicLink>
                                    </Grid>
                                )}
                                <Grid item md="auto" sm={1}>
                                    <IconButton
                                        aria-label="Delete"
                                        className="alerts-page-card__deleteButton"
                                        onClick={removeAlert}
                                    >
                                        <DeleteIcon color="primary" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Grid>
            </CardContent>
            {removeAlertState.error && (
                <Typography align="center" className="alerts-page-card__error" color="error" gutterBottom variant="h5">
                    {removeAlertState.error.errorMessage || t("genericError")}
                </Typography>
            )}
            <Hidden smUp>
                <VariantCardActions>
                    <Grid item xs={navLinkLabel ? 6 : 12}>
                        <Button aria-label="Delete" color="primary" fullWidth variant="contained" onClick={removeAlert}>
                            <DeleteIcon />
                        </Button>
                    </Grid>
                    {navLinkLabel && (
                        <Grid item xs={6}>
                            <DynamicLink link={navLink}>
                                <Button color="secondary" fullWidth variant="contained">
                                    {navLinkLabel}
                                </Button>
                            </DynamicLink>
                        </Grid>
                    )}
                </VariantCardActions>
            </Hidden>
            {isLoading && <AbsoluteLoader size={40} />}
        </Card>
    );
};
